/* The popover of the Lienzo hero's design chip. */
.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  font-size: var(--font-size-13);
}

.panel p {
  margin: 0;
}

.meta {
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}

.link {
  color: var(--action-text);
  font-weight: var(--font-weight-medium);
}

.error {
  color: var(--danger-text);
}
